import Page from "@/shared/page";
import { useParams } from "react-router-dom";
import { DYNAMIC_ATTRIBUTES_LIST_PAGE } from "./attributes-list-page-path";
import { useTranslations } from "use-intl";
import { DynamicAttributeEntity } from "gql/graphql";
import { DynamicAttributeEditor } from "../../widgets/dynamic-attribute-editor";

export default function AttributeListPage() {
  const { entity } = useParams<{ entity: DynamicAttributeEntity }>();
  const t = useTranslations("EntityAttributeView");
  const entityName = entity as string;

  if (!entity) {
    return;
  }

  return (
    <Page
      title={entityName}
      breadcrumbsOptions={{
        path: DYNAMIC_ATTRIBUTES_LIST_PAGE,
        entityNames: {
          entity: t(entityName),
        },
      }}
    >
      <DynamicAttributeEditor
        config={{
          entity,
          useSelectedGroupAsQueryParam: true,
        }}
      />
    </Page>
  );
}
